import { Box, Divider, Stack, Typography } from "@mui/material";
import { CloseIcon, Tooltip } from "components";
import { CustomToggleButton } from "library/base";
import { NewUser } from "../../types";
import CrownIcon from "assets/crown.svg";
import { Dispatch } from "react";

export const AddedUsersList = ({
  newUsers,
  setNewUsers,
  setUserErrors,
}: {
  newUsers: NewUser[];
  setNewUsers: Dispatch<any>;
  setUserErrors: Dispatch<any>;
}) => {
  const updatePreivilageUserStatus = (user: any) => {
    setNewUsers((prevUserList: NewUser[]) => {
      const updatedUserList = prevUserList.map((u: any) => {
        if (u.email === user.email) {
          return {
            ...u,
            IsPrivileged: !u?.IsPrivileged,
          };
        }
        return u;
      });
      return updatedUserList;
    });
  };
  const removeUser = (user: any) => {
    setNewUsers((prevUserList: any) =>
      prevUserList.filter((u: any) => u?.email !== user?.email),
    );
    setUserErrors([]);
  };
  return (
    <Stack
      sx={{
        maxHeight: "300px",
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      {newUsers.map((item: any, index: any) => (
        <div key={item.email}>
          {index === 0 && <Divider />}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              alignItems: "center",
              p: "8px 16px",
              columnGap: "8px",
            }}
          >
            <Typography
              variant="body-small"
              sx={{
                textTransform: "capitalize",
                display: "inline-block",
                maxWidth: "189px",
                whiteSpace: "noWrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {item.full_name}
            </Typography>
            <Tooltip title={item.email} placement="top-start">
              <Typography
                variant="link-small"
                sx={{
                  display: "inline-block",
                  maxWidth: "189px",
                  whiteSpace: "noWrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {item.email}
              </Typography>
            </Tooltip>
            <Stack direction={"row"} alignItems={"center"} gap={"16px"}>
              <Stack direction={"row"} alignItems={"center"} gap={"8px"}>
                <img
                  src={CrownIcon}
                  alt="crown"
                  style={{ width: "20px", height: "20px" }}
                />
                <Typography variant="body-medium">Privileged</Typography>
                <CustomToggleButton
                  name={"is_active"}
                  isChecked={item?.IsPrivileged}
                  isDisabled={false}
                  onChange={() => {
                    updatePreivilageUserStatus(item);
                  }}
                />
              </Stack>
              <CloseIcon
                fontSize="small"
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  removeUser(item);
                }}
              />
            </Stack>
          </Box>
          <Divider />
        </div>
      ))}
    </Stack>
  );
};
